import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useFeatureToggle } from '@flopflip/react-redux';
import { Tooltip, Typography } from '@mui/material';
import { PhoneIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import { FeatureFlag } from 'constants/featureFlags';
import useCompanyId from 'hooks/useCompanyId';

import { extensionMakeCallAction, makeCallWithDialogAction } from 'store/loanApplications/actions';

const TOOLTIP_POPOVER_PROPS = { style: { zIndex: 1300 } };

const ContactRow = ({
  fullName = '',
  emailAddress = '',
  phoneNumber = '',
  description = '',
  applicationId,
}) => {
  const companyId = useCompanyId();

  const isCallConfirmationEnabled = useFeatureToggle(FeatureFlag.EnableCallConfirmation);

  const dispatch = useDispatch();

  const onPhoneNumberClick = useCallback(() => {
    if (phoneNumber) {
      if (isCallConfirmationEnabled) {
        dispatch(makeCallWithDialogAction({ applicationId, fullName, companyId, phoneNumber }));

        return;
      }

      dispatch(
        extensionMakeCallAction({
          applicationId,
          fullName,
          companyId,
          phoneNumber,
        }),
      );
    }
  }, [applicationId, companyId, dispatch, fullName, phoneNumber, isCallConfirmationEnabled]);

  return (
    <div className="py-5 grid md:grid-cols-4 gap-20">
      <Tooltip PopperProps={TOOLTIP_POPOVER_PROPS} title={fullName || 'N/A'}>
        <div className="min-w-0">
          <Typography className="py-1 mr-auto truncate" variant="bold14">
            {fullName || 'N/A'}
          </Typography>
        </div>
      </Tooltip>
      <Typography className="py-1 m-auto truncate" variant="bold14">
        {description || 'N/A'}
      </Typography>
      <Tooltip PopperProps={TOOLTIP_POPOVER_PROPS} title={emailAddress || 'N/A'}>
        <div className="min-w-0">
          <Typography className="py-1 m-auto min-w-0 truncate" variant="regular14">
            {emailAddress || 'N/A'}
          </Typography>
        </div>
      </Tooltip>
      <div
        className={`flex flex-row m-auto min-w-0 ${phoneNumber ? 'cursor-pointer' : ''}`}
        onClick={onPhoneNumberClick}
      >
        <Typography className="py-1 truncate underline" variant="regular14">
          {phoneNumber || 'N/A'}
        </Typography>
        <PhoneIcon className="ml-1 my-auto" size={IconSize[16]} />
      </div>
    </div>
  );
};

ContactRow.propTypes = {
  applicationId: PropTypes.string.isRequired,
  description: PropTypes.string,
  emailAddress: PropTypes.string,
  fullName: PropTypes.string,
  phoneNumber: PropTypes.string,
};

export default ContactRow;
